var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"container"},[_c('h1',[_vm._v("Garage Rats Car Club")]),_c('h2',[_vm._v("Erie, Colorado")])])
}]

export { render, staticRenderFns }